import React from "react";

function internalServerError() {
  return (
    <div className="col-md-8 col-md-offset-2 takataRecall ">
      <div className="carDetails">
        <div className="carDetails__wrap">
          <h2 className="carDetails__heading h5">Something went wrong</h2>
          <p className="carDetails__statusMessage ">
            Sorry, something went wrong while processing your request. Please try again.
          </p>
        </div>
      </div>
    </div>
  );
}

export default internalServerError;
